import {
	USERS,
	SET_USERS,
	LOADING,
	SET_LOADING,
	TOAST_MESSAGES_PUSH,
	RELOAD_USERS,
	SET_RELOAD_USERS,
	USER_HISTORY_LOGS,
	SET_USER_HISTORY_LOGS
} from './users-mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { mergePayloadObjects } from '@/utils/object';
import { isObject } from '@/utils/inspect';

import _ from 'lodash';

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'users',
	namespaced: true,
	state: {
		users: {},
		[USER_HISTORY_LOGS]: {},
		[LOADING]: false,
		[RELOAD_USERS]: false
	},
	mutations: {
		[SET_USERS](state, obj) {
			state[USERS] = obj;
		},
		[SET_LOADING](state, val) {
			state[LOADING] = val;
		},
		[SET_RELOAD_USERS](state, val) {
			state[RELOAD_USERS] = val;
		},
		[SET_USER_HISTORY_LOGS](state, obj) {
			state[USER_HISTORY_LOGS] = obj;
		}
	},
	actions: {
		async setUsers({ dispatch, commit, state }, parameters) {
			const { page } = parameters;
			if (page === 1) {
				commit(SET_USERS, {});
			}
			await api
				.get(buildRoute('/users', parameters))
				.then(response => {
					if (_.isEmpty(state.users)) {
						commit(SET_USERS, response);
					} else {
						let currentStore = _.cloneDeep(state.users);
						let usersPayload = mergePayloadObjects(
							currentStore,
							response
						);
						commit(SET_USERS, usersPayload);
					}
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}

					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
			commit(SET_LOADING, false);
			commit(SET_RELOAD_USERS, false);
		},
		async getUser({ dispatch }, userId) {
			let result = {};
			let isSuccessful = true;
			await api
				.get(`/users/${userId}`)
				.then(resp => {
					result = _.cloneDeep(resp);
				})
				.catch(error => {
					isSuccessful = false;
					let message = error
						? error
						: `UserId ${userId} does not exist.`;
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 400,
							message: message
						},
						{
							root: true
						}
					);
				});
			Object.assign(result, { isSuccessful: isSuccessful });

			return result;
		},
		[SET_RELOAD_USERS]({ commit }, val) {
			commit(SET_RELOAD_USERS, val);
		},
		async [SET_USER_HISTORY_LOGS]({ dispatch, commit }, parameters) {
			await api
				.post(`/versionhistory`, parameters)
				.then(response => {
					commit(SET_USER_HISTORY_LOGS, response);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
		},
		async updateUser({ dispatch, commit }, user) {
			let result = {};
			let isSuccessful = true;
			let toastObj = {
				statusCode: 200,
				message: 'User successfully updated.'
			};
			await api
				.put(`/users/${user.userId}`, user)
				.then(resp => {
					if (!_.isEmpty(resp)) {
						result = _.cloneDeep(resp);

						let oidcUser = _.cloneDeep(
							JSON.parse(localStorage.getItem('oidcUser'))
						);
						if (result.email === oidcUser.Email) {
							const SupportRole = resp.roles.map(
								role => role.role
							);
							oidcUser.SupportRole = SupportRole;

							localStorage.setItem(
								'oidcUser',
								JSON.stringify(oidcUser)
							);
						}

						commit(SET_RELOAD_USERS, true);
					}
				})
				.catch(error => {
					isSuccessful = false;
					if (isObject(error)) {
						Object.assign(result, error);
					}
					if (error && typeof error === 'string') {
						Object.assign(result, { message: error });
					}
				});
			if (isSuccessful) {
				dispatch(TOAST_MESSAGES_PUSH, toastObj, {
					root: true
				});
			}
			Object.assign(result, { isSuccessful: isSuccessful });

			return result;
		},
		async createUser({ dispatch, commit }, payload) {
			let result = {};
			let isSuccessful = true;
			let toastObj = {
				statusCode: 200,
				message: 'User successfully created.'
			};
			await api
				.post('/users', payload)
				.then(resp => {
					if (!_.isEmpty(resp)) {
						result = _.cloneDeep(resp);
						commit(SET_RELOAD_USERS, true);
					}
				})
				.catch(error => {
					isSuccessful = false;
					if (isObject(error)) {
						Object.assign(result, error);
					}
					if (error && typeof error === 'string') {
						Object.assign(result, { message: error });
					}
				});
			if (isSuccessful) {
				dispatch(TOAST_MESSAGES_PUSH, toastObj, {
					root: true
				});
			}
			Object.assign(result, { isSuccessful: isSuccessful });

			return result;
		},
		async updateUserLock(
			{ dispatch, commit },
			{ userId, globalEmployeeId }
		) {
			let isSuccessful = true;
			let toastObj = {
				statusCode: 200,
				message: 'User successfully unlocked.'
			};
			await api
				.post(`/users/unlock/${userId}`, {
					UserId: userId,
					globalEmployeeId: globalEmployeeId
				})
				.then(() => {
					commit(SET_RELOAD_USERS, true);
				})
				.catch(error => {
					isSuccessful = false;
					let messageMsg = error;
					if (!messageMsg) {
						messageMsg = 'User unsuccessfully unlocked.';
					}
					toastObj.statusCode = 400;
					toastObj.message = messageMsg;
				})
				.finally(() => {
					dispatch(TOAST_MESSAGES_PUSH, toastObj, {
						root: true
					});
				});
			return isSuccessful;
		}
	},
	getters: {
		[USERS]: state => state[USERS],
		[LOADING]: state => state[LOADING],
		[RELOAD_USERS]: state => state[RELOAD_USERS],
		[USER_HISTORY_LOGS]: state => state[USER_HISTORY_LOGS]
		//[OIDC_USER_PROFILE]: state => state[OIDC_USER_PROFILE]
	}
};
